import { CustomScene } from '../types/types'

export const getSelectedPendantLabels = (allScenes: CustomScene[]) => {
  return allScenes
    .map((scene) => {
      const isPendantScene = scene?.isPendantScene
      //  SASX-197 -- re enable this
      // const isDiamondSelectionScene = scene?.name.toLowerCase().includes('diamond')
      const currentPendantVariantStepTags = scene.steps.find((step) => step.getTags().includes('pendant-selection'))?.getTags()
      const currentPendantSummaryName = currentPendantVariantStepTags?.find((tag) => tag.includes('summary-name'))?.split(':')[1]
      const isBirthstoneStep = !!currentPendantVariantStepTags?.find((tag) => tag.includes('birthstone-step'))

      //  SASX-197 -- add early exit here to handle diamond. refer to DiamondPendantSelectionLabel for the desired format
      // also check Summary.txt -- should be able to copy most from the existing labels in Summary.

      const variantLabel = scene?.variants.flatMap((variant) => {
        // @ts-expect-error - Spiff types are missing the metadata property
        const metadataVariantName = variant?.variantData?.thumbnail?.metadata.find((metadata) => metadata.key === 'variant_name')?.value.toLowerCase()
        const variantName = variant.getName().toLowerCase()

        if (!currentPendantSummaryName) return variantName

        if (isBirthstoneStep) {
          return `${currentPendantSummaryName}: ${variantName} (${metadataVariantName})`
        }

        return `${currentPendantSummaryName} (${variantName})`
      })

      return isPendantScene && variantLabel[0]
    })
    .filter((label) => label) as string[]
}
